import { useApplication } from "../../context/app";
import { onMount } from "solid-js";
import { useParams } from "@solidjs/router";
import { TextInput } from "../../components/ui/form/TextInput";
import { TextAreaInput } from "../../components/ui/form/TextAreaInput";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardTitle
} from "@/components/shadcn/card";
import { LoadingButton } from "../../components/ui/Button";
import ImageUploader from "../../components/ui/ImageUploader";;
import useDoctorForm from "../../services/useDoctorForm";

export default function DoctorForm() {

  const { setBreadcrumb } = useApplication();

  const {
    form,
    handleChange,
    handleSave,
    handlePhotoChange,
    fetchInfo,
    loading
  } = useDoctorForm();

  const params = useParams();
  if (params.key !== undefined && params.key !== null) {
    fetchInfo(params.key);
  }

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Doctor',
        link: '/doctors'
      },
      {
        name: params.key !== undefined && params.key !== null ? 'Edit' : 'Create',
        current: true
      }
    ]);
  });

  return (
    <div className="main-card">
      <form autocomplete="off">
        <div class="grid grid-cols-12 gap-2">
          <Card class="lg:col-span-3 sm:col-span-6 col-span-12">
            <CardHeader class="pb-2">
              <CardTitle>Change Photo</CardTitle>
              <CardDescription class="text-sm">Photo should be at least 100px x 100px</CardDescription>
            </CardHeader>
            <CardContent>
              <ImageUploader
                onPhotoChanged={handlePhotoChange}
                placeholder={form.photoURL}
                width="128px"
                height="128px"
                uploadBtnText=""
                resetBtnText=""
              />
            </CardContent>
          </Card>
          <Card class="lg:col-span-4 sm:col-span-6 col-span-12">
            <CardHeader>
              <CardTitle>Account Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="form-group">
                <TextInput
                  label="Email"
                  name="email"
                  form={form}
                  input={handleChange}
                />
              </div>
              <div class="form-group">
                <TextInput
                  label="Username"
                  name="username"
                  form={form}
                  input={handleChange}
                />
              </div>
              <div class="form-group">
                <TextInput
                  label="Phone"
                  name="phone"
                  form={form}
                  input={handleChange}
                />
              </div>
              <div class="form-group">
                <TextInput
                  type="password"
                  label="Password"
                  name="password"
                  form={form}
                  input={handleChange}
                />
              </div>
            </CardContent>
          </Card>
          <Card class="lg:col-span-5 col-span-12">
            <CardHeader>
              <CardTitle>Basic Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="grid grid-cols-4 gap-1">
                <div class="form-group col-span-4">
                  <TextInput
                    label="Full Name"
                    name="name"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextInput
                    label="NIC No"
                    name="nic"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Qualifications"
                    name="qualifications"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Specialization"
                    name="specialization"
                    form={form}
                    input={handleChange}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div class="text-end mt-3">
          <LoadingButton loading={loading()} onClick={handleSave}>Save</LoadingButton>
        </div>
      </form>
    </div>
  );
}
